export const service_url = "https://medimaps.org";
